import cookie from 'js-cookie'

import type { MeetingDoctorsCookieStrategy } from './cookie.constants'
import type { StorageInterface } from './storage.interface'

export type CookieRepositoryStrategy = MeetingDoctorsCookieStrategy

export class CookieRepository implements StorageInterface {
  private strategy: CookieRepositoryStrategy

  constructor(strategy: CookieRepositoryStrategy) {
    this.strategy = strategy
  }

  set(key: string, value: string): void {
    cookie.set(key, value, this.strategy)
  }

  get(key: string): string | null {
    return cookie.get(key) || null
  }

  remove(key: string): void {
    cookie.remove(key, this.strategy)
  }

  clear(): void {}
}
